export const isNumber = (input) => /^\d+$/.test(input);
